import React from "react";

import "./Toolbox.scss";

export default function Toolbox(props) {
  return <div className={"toolbox"}>{props.children}</div>;
}
